import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import SelectField from "../../../components/SelectField";

export default function PrestatorStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Tip prestator"
        value={data.prestatorTip}
        onChange={update("prestatorTip")}
        options={[
          { value: "pf", label: "Persoana fizica" },
          { value: "pfa", label: "PFA (Persoana Fizica Autorizata)" },
          { value: "srl", label: "SRL (Societate cu Raspundere Limitata)" },
        ]}
      />

      {data.prestatorTip === "pf" && (
        <>
          <InputField label="Nume complet" value={data.prestatorNume} onChange={update("prestatorNume")} placeholder="ex: Popescu Ion" required error={errors.prestatorNume} />
          <InputField label="Adresa de domiciliu" value={data.prestatorAdresa} onChange={update("prestatorAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.prestatorAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.prestatorCNP} onChange={update("prestatorCNP")} placeholder="ex: 1234567890123" half error={errors.prestatorCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.prestatorCI} onChange={update("prestatorCI")} placeholder="ex: RD 123456" half error={errors.prestatorCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}

      {data.prestatorTip === "pfa" && (
        <>
          <InputField label="Denumire PFA" value={data.prestatorDenumire} onChange={update("prestatorDenumire")} placeholder="ex: Popescu Ion PFA" required error={errors.prestatorDenumire} />
          <InputField label="CUI" value={data.prestatorCUI} onChange={update("prestatorCUI")} placeholder="ex: 12345678" required half error={errors.prestatorCUI} />
          <InputField label="Sediu profesional" value={data.prestatorSediu} onChange={update("prestatorSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.prestatorSediu} />
          <InputField label="Reprezentant" value={data.prestatorReprezentant} onChange={update("prestatorReprezentant")} placeholder="ex: Popescu Ion" required half error={errors.prestatorReprezentant} />
        </>
      )}

      {data.prestatorTip === "srl" && (
        <>
          <InputField label="Denumire societate" value={data.prestatorDenumire} onChange={update("prestatorDenumire")} placeholder="ex: SC Exemplu SRL" required error={errors.prestatorDenumire} />
          <InputField label="CUI" value={data.prestatorCUI} onChange={update("prestatorCUI")} placeholder="ex: RO12345678" required half error={errors.prestatorCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.prestatorRegCom} onChange={update("prestatorRegCom")} placeholder="ex: J40/1234/2020" half />
          <InputField label="Sediu social" value={data.prestatorSediu} onChange={update("prestatorSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.prestatorSediu} />
          <InputField label="Reprezentant legal" value={data.prestatorReprezentant} onChange={update("prestatorReprezentant")} placeholder="ex: Popescu Ion" required error={errors.prestatorReprezentant} />
        </>
      )}
    </div>
  );
}
